module.exports = __webpack_public_path__ + "img/InfoPaginas.ec3c6188.svg";